import {combineReducers} from 'redux';
import AuthReducer from './AuthReducer';  
import CategoryReducer from './CategoryReducer';  
import cartReducer from './CartReducer';  
import { productsApi } from '../store/api/productsApi';

const rootReducer=combineReducers({
      productData:AuthReducer, 
      category:CategoryReducer,
      cart:cartReducer,
      // RTK Query reducer
      [productsApi.reducerPath]: productsApi.reducer
});

export default rootReducer;
